<template>
  <v-sheet class="pa-3">
    <!-- Datos del Proveedor/Cliente -->
    <v-row>
      <v-col cols="12" sm="6" md="4">
        <v-text-field
          label="Nombre"
          :value="data.cliente"
          filled
          rounded
          dense
          readonly
        ></v-text-field>
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <v-text-field
          label="Direccion"
          :value="data.idpersona.direccion"
          filled
          rounded
          dense
          readonly
        ></v-text-field>
      </v-col>

      <v-col cols="12" sm="2" md="2">
        <v-text-field
          label="Nit"
          :value="data.idpersona.nit"
          filled
          rounded
          dense
          readonly
        ></v-text-field>
      </v-col>
    </v-row>


    <!-- Datos del Comprobante -->
    <v-row>
      <v-col cols="12" sm="6" md="3">
        <v-text-field
          label="Tipo Comprobante"
          :value="data.documento"
          filled
          rounded
          dense
          readonly
        ></v-text-field>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-text-field
          label="Serie"
          placeholder="Serie comprobante"
          :value="data.serie"
          filled
          rounded
          dense
          readonly
        ></v-text-field>
      </v-col>

      <v-col cols="12" sm="2" md="2">
        <v-text-field
          label="Número"
          placeholder="Número comprobante"
          :value="data.numero"
          filled
          rounded
          dense
          readonly
        ></v-text-field>
      </v-col>

      <v-col cols="12" sm="2" md="4">
        <v-text-field
          label="Fecha"
          placeholder="Fecha comprobante"
          :value="data.fecha | formatFecha"
          filled
          rounded
          dense
          readonly
        ></v-text-field>
      </v-col>

    </v-row>

  </v-sheet>
</template>
<script>
import dayjs from "dayjs";

export default {
  props:["data"],
  filters: {
     formatFecha: function (value) {
      if (!value) return "";
      return dayjs(value).format("DD-MM-YYYY H:mm:ss");
    },
  }
}
</script>

